var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotaFiscal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "receipt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "100 0 810 1010",
    enableBackground: "new 0 0 1010 1010",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "receipt-receipt"
  }, /*#__PURE__*/React.createElement("g", {
    id: "receipt-receipt_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M348.6279,330.6562l-0.3652-0.0986H236.7583l1.144-11.1255c4.0635-39.4433,31.0889-81.895,80.8497-81.895 h42.1357v95.0918L348.6279,330.6562z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF00",
    d: "M458.6621,772.4727c-52.6499,0-97.7744-54.9981-97.7744-100.0235V237.5371h232.5762 c31.6025,0,69.7724,25.9307,69.7724,58.1445v371.1553c0.0791,0.335,0.1387,0.6611,0.1973,0.9961l1.7461,11.6084H563.3315 C563.3315,725.5234,510.5039,772.4727,458.6621,772.4727L458.6621,772.4727z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M488.8047,772.4727l28.061-18.5333c25.3384-16.7286,42.481-41.3174,45.8643-65.7784l1.2031-8.7197 h209.3091l-1.1445,11.1367c-4.0538,39.4424-31.0791,81.8946-80.8301,81.8946H488.8047z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M691.2676,782.5723H458.6621c-5.582,0-10.0996-4.5176-10.0996-10.0996 c0-5.5831,4.5176-10.1006,10.0996-10.1006c45.9629,0,94.5693-42.6288,94.5693-82.9307c0-5.582,4.5176-10.0996,10.1001-10.0996 h209.3384c5.5822,0,10.0996,4.5176,10.0996,10.0996C782.7695,729.4395,750.7041,782.5723,691.2676,782.5723L691.2676,782.5723z  M522.4287,762.3721h168.8389c42.4424,0,66.9824-35.8819,70.7793-72.8301H572.7314 C568.8252,717.8008,549.02,744.8154,522.4287,762.3721L522.4287,762.3721z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M349.2588,340.6582H237.3301c-5.5821,0-10.0996-4.5176-10.0996-10.1006 c0-49.9868,32.0752-103.1201,91.5215-103.1201h274.7119c5.583,0,10.1006,4.5171,10.1006,10.0996 c0,5.583-4.5176,10.1001-10.1006,10.1001H318.752c-42.4517,0-66.9918,35.8828-70.7989,72.8208h101.3057 c5.583,0,10.1001,4.5176,10.1001,10.0996C359.3589,336.1406,354.8418,340.6582,349.2588,340.6582L349.2588,340.6582z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M458.6621,782.5723c-59.7515,0-107.8745-60.2452-107.8745-110.1231V237.5371 c0-5.5825,4.5176-10.0996,10.1001-10.0996s10.1001,4.5171,10.1001,10.0996v434.9121c0,39.6406,41.2778,89.9229,87.6743,89.9229 c5.583,0,10.1006,4.5175,10.1006,10.1006C468.7627,778.0547,464.2451,782.5723,458.6621,782.5723L458.6621,782.5723z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M663.2363,677.9131c-5.582,0-10.0995-4.5176-10.0995-10.1006V295.6816 c0-5.583,4.5176-10.1005,10.0995-10.1005c5.583,0,10.1006,4.5175,10.1006,10.1005v372.1309 C673.3369,673.3955,668.8193,677.9131,663.2363,677.9131L663.2363,677.9131z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M663.2363,305.7812c-5.582,0-10.0995-4.5175-10.0995-10.0996c0-25.8715-32.8154-48.0444-59.6729-48.0444 c-5.5829,0-10.1006-4.5171-10.1006-10.1001c0-5.5825,4.5176-10.0996,10.1006-10.0996c36.9384,0,79.873,29.8066,79.873,68.2441 C673.3369,301.2637,668.8193,305.7812,663.2363,305.7812L663.2363,305.7812z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "624.6914,562.5918 577.5938,562.5918 577.5938,542.3916 624.6914,542.3916 624.6914,562.5918  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "624.6914,619.1377 577.5938,619.1377 577.5938,598.9375 624.6914,598.9375 624.6914,619.1377  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "486.3389,336.3281 398.6445,336.3281 398.6445,316.1279 486.3389,316.1279 486.3389,336.3281  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "624.6914,392.8936 577.5938,392.8936 577.5938,372.6938 624.6914,372.6938 624.6914,392.8936  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "624.6914,449.4502 577.5938,449.4502 577.5938,429.25 624.6914,429.25 624.6914,449.4502  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "624.6914,506.0156 577.5938,506.0156 577.5938,485.8164 624.6914,485.8164 624.6914,506.0156  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "530.5068,392.8936 398.6445,392.8936 398.6445,372.6938 530.5068,372.6938 530.5068,392.8936  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "530.5068,449.4502 398.6445,449.4502 398.6445,429.25 530.5068,429.25 530.5068,449.4502  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "530.5068,506.0156 398.6445,506.0156 398.6445,485.8164 530.5068,485.8164 530.5068,506.0156  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "530.5068,562.5918 398.6445,562.5918 398.6445,542.3916 530.5068,542.3916 530.5068,562.5918  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "530.5068,619.1377 398.6445,619.1377 398.6445,598.9375 530.5068,598.9375 530.5068,619.1377  "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotaFiscal);
export default __webpack_public_path__ + "static/media/nota-fiscal.a532afa32b0ab4fe1da1a6806eb44e4c.svg";
export { ForwardRef as ReactComponent };